import { Button } from '~/shared/components/buttons/Button';
import { Plus } from 'lucide-react';
import { DischargePlanFormModal } from './forms/DischargePlanFormModal';
import { Callout } from '~/shared/components/Callout';

export function NoDischargePlanFound({ certificationPeriodId }: { certificationPeriodId: string }) {
	return (
		<div>
			<Callout title="`No discharge plan found" subtitle="Click the button below to add a discharge plan">
				<Button
					Icon={Plus}
					aria-label="Add Discharge Plan"
					intent="neutral"
					renderModal={closeModal => <DischargePlanFormModal certificationPeriodId={certificationPeriodId} closeModal={closeModal} />}
				/>
			</Callout>
		</div>
	);
}
